import Defaults from '../../constants/defaults';

export default class Card {
	from = 0;

	to = Defaults.KCARDN;

	/**
	 * @param {string | {from: number, to: number | 'N' } | number} from
	 * @param {number | 'N' | undefined} to
	 */
	constructor(from, to = undefined) {
		if (typeof from === 'string' && to === undefined) {
			const temporaryCard = from.split('-');
			if (temporaryCard.length === 2) {
				this.from = Number.parseInt(temporaryCard[0], 10);
				this.to = temporaryCard[1] === 'N' ? Defaults.KCARDN : Number.parseInt(temporaryCard[1], 10);
			}
		}
		else if (typeof from === 'object' && 'from' in from && 'to' in from) {
			this.from = from.from;
			this.to = from.to === 'N' ? Defaults.KCARDN : from.to;
		}
		else {
			this.from = typeof from === 'string' ? Number.parseInt(from, 10) : from;
			this.to = (
				typeof to === 'string'
					? (to === 'N' ? Defaults.KCARDN : Number.parseInt(to, 10))
					: to
			) ?? Defaults.KCARDN;
		}
	}

	check() {
		return this.from <= this.to;
	}

	/**
	 * @param {'from' | 'to'} t
	 * @returns {string | undefined}
	 */
	getString(t) {
		if (t === 'from') {
			return `${this.from}`;
		}
		if (t === 'to') {
			return `${this.to === Defaults.KCARDN ? 'N' : this.to}`;
		}
		return undefined;
	}

	isMultiple() {
		return this.to > 1;
	}

	isRequired() {
		return this.from > 0;
	}

	toString() {
		return `${this.getString('from')}-${this.getString('to')}`;
	}
}
